import { Modal } from 'antd';
import styled from 'styled-components';

export default styled(Modal)`
  .ant-form-item-explain {
    color: red;
  }
`;
